<template>
<div class="nj-info">
    <div class="nj-info--label">{{ label }}:</div>
    <div class="nj-info--value">
        <slot></slot>
    </div>
</div>
</template>

<script>
export default {
    name: "Info",
    props: {
        label: {
            required: true
        },
    }
}
</script>

<style scoped>
.nj-info {
    display: flex;
    flex-flow: column;
    justify-content: space-between;
    gap: 0;
    margin: 0 0 6px 0;
}

.nj-info--label {
    font-weight: bold;
    display: block;
    padding: 4px 4px 2px 4px;
}

.nj-info--value {
    display: block;
    padding: 2px 4px 4px 4px;
}
</style>